const Sobre = () => (
  <section id="sobre" className="bg-[#111111] py-24 px-6 md:px-10">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Left: Image */}
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden h-[500px]">
            <img
              src="https://public.readdy.ai/ai/img_res/e9c1d766c20711bbcac67cc1fceeaa3d.jpg"
              alt="Piloto profissional de drone"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>

          {/* Badge */}
          <div className="absolute top-6 left-6 bg-black/70 backdrop-blur-sm border border-white/20 text-white rounded-xl px-4 py-3 flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-[#f5a623] rounded-lg">
              <i className="ri-shield-check-line text-black text-sm"></i>
            </div>
            <div>
              <div className="text-xs font-bold">Certificado ANAC</div>
              <div className="text-white/60 text-xs">Operador Habilitado</div>
            </div>
          </div>
        </div>

        {/* Right: Content */}
        <div>
          <span className="inline-flex items-center gap-2 text-[#f5a623] text-xs font-bold tracking-widest uppercase mb-6">
            <span className="w-8 h-px bg-[#f5a623]"></span>
            Sobre a Drone Fácil SP
          </span>

          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
            Especialistas em<br />
            <span className="text-[#f5a623]">Imagens Aéreas</span><br />
            em São Paulo
          </h2>

          <p className="text-white/60 text-base leading-relaxed mb-6">
            Somos uma empresa paulistana especializada em serviços aéreos com drone, atuando desde 2016 com foco em qualidade, segurança e resultados que superam expectativas. Nossa equipe é formada por pilotos certificados pela ANAC e profissionais de imagem com vasta experiência no mercado.
          </p>

          <p className="text-white/60 text-base leading-relaxed mb-10">
            Atendemos construtoras, imobiliárias, agências de eventos e empresas de engenharia em toda a Grande São Paulo, entregando imagens e dados aéreos de altíssima precisão e qualidade.
          </p>

          {/* Values */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
            {[
              { icon: 'ri-shield-check-line', title: 'Segurança Total', desc: 'Operações 100% dentro das normas ANAC e DECEA' },
              { icon: 'ri-time-line', title: 'Pontualidade', desc: 'Entrega no prazo combinado, sempre' },
              { icon: 'ri-4k-line', title: 'Alta Qualidade', desc: 'Equipamentos DJI de última geração' },
              { icon: 'ri-customer-service-2-line', title: 'Suporte Ágil', desc: 'Atendimento rápido via WhatsApp' },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-3 bg-[#1a1a1a] border border-white/8 rounded-xl p-4">
                <div className="w-9 h-9 flex items-center justify-center bg-[#f5a623]/15 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-[#f5a623] text-base`}></i>
                </div>
                <div>
                  <div className="text-white text-sm font-semibold mb-1">{item.title}</div>
                  <div className="text-white/50 text-xs leading-relaxed">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <a
            href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-7 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Fale Conosco no WhatsApp
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Sobre;
